import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { ItemTipo } from '../item-tipo';
import { ItemTipoFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class ItemTipoCrudHttpService implements Crud<ItemTipo> {
    resource = 'itemtipo';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todos os tipos de item cadastrados */
    search(): Observable<ItemTipo[]> {
        return this.crudService.search<ItemTipo>(this.resource);
    }

    /** Pesquisa todos os tipos de itens cadastrados utilizando os filtros informados */
    searchWithFilter(filter: ItemTipoFilter): Observable<ItemTipo[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }
        return this.crudService.search<ItemTipo>(this.resource, {params});
    }

    /** Procura um único tipo de item através do seu ID */
    find(id: number): Observable<ItemTipo> {
        return this.crudService.find<ItemTipo>(this.resource, id);
    }

    /** Carrega um único tipo de item através do seu ID */
    load(id: number): Observable<ItemTipo> {
        return this.crudService.load<ItemTipo>(this.resource, id);
    }

    /** Insere um novo tipo de item */
    insert(entity: ItemTipo): Observable<ItemTipo> {
        return this.crudService.insert<ItemTipo>(this.resource, entity);
    }

    /** Altera uma tipo de item existente */
    update(entity: ItemTipo): Observable<ItemTipo> {
        return this.crudService.update<ItemTipo>(this.resource, entity);
    }

    /** Exclui uma tipo de item através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
